import React, { useState, useEffect } from 'react';
import { Box, Flex, Button, IconButton, Image, Avatar } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants/FrontendPathConstants';

interface UserData {
  email?: string;
  first_name?: string;
  last_name?: string;
  photoUrl?: string;
}

interface HeaderProps {
  isSidebarOpen: boolean;
}

const Header = ({ isSidebarOpen }: HeaderProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [userData, setUserData] = useState<UserData | null>(null);

  useEffect(() => {
    const stored = localStorage.getItem('userData');
    if (stored) setUserData(JSON.parse(stored));
  }, []);

  const userName = userData
    ? `${userData.first_name || ''} ${userData.last_name || ''}`.trim()
    : '';

  const showProjectReportLogo = /^\/projects\/[^/]+\/reports\b/.test(pathname);

  return (
    <Box
      as="header"
      width="100%"
      height="80px"
      bg="white"
      borderBottom="1px solid"
      borderColor="surface.300"
      display="flex"
      alignItems="center"
      px={6}
      zIndex={15}
      flexShrink={0}
    >
      {/* Logo - visible when sidebar is closed or on specific pages */}
      {!isSidebarOpen && (
        <Image
          src="/images/Seq4life blue logo.png"
          alt="Seq4Life"
          h="64px"
          objectFit="contain"
          cursor="pointer"
          onClick={() => navigate(ROUTES.DASHBOARD)}
          ml={14}
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s ease"
        />
      )}

      {showProjectReportLogo && (
        <Image
          src="/images/UGenomeHorizontalBlue.png"
          alt="UGenome Logo"
          height="48px"
          cursor="pointer"
          onClick={() => navigate(ROUTES.DASHBOARD)}
          ml={isSidebarOpen ? 0 : 4}
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s ease"
        />
      )}

      {/* Right side actions */}
      <Flex justify="flex-end" flex={1} alignItems="center" gap={3}>
        <Button
          onClick={() => navigate(ROUTES.INTRODUCTION)}
          variant="primary"
          size="sm"
          borderRadius="full"
          px={6}
          fontWeight="semibold"
          _hover={{
            transform: 'translateY(-1px)',
            boxShadow: 'md',
          }}
        >
          Dashboard
        </Button>

        <IconButton
          aria-label="Go to Profile"
          variant="ghost"
          onClick={() => navigate(ROUTES.PROFILE)}
          borderRadius="full"
          size="lg"
          w="48px"
          h="48px"
          _hover={{
            bg: 'surface.200',
          }}
          icon={
            <Avatar
              size="md"
              bg="primary.500"
              color="white"
              name={userName || 'User'}
              src={userData?.photoUrl || ''}
            />
          }
        />
      </Flex>
    </Box>
  );
};

export default Header;
